import { Component } from '@angular/core';
import { MdInputContainer, MdDatepicker } from '@angular/material';

import { NceService } from '../services/nce.service';
import { STATIC_VALUE } from '../../shared/configuration/static.value';

import { StorageService } from '../../shared/services/storage.service';
import { PageNavigationService } from '../../shared/services/page-navigation.service';
import { LayoutService } from '../../shared/services/layout.service';
import { ErrorService } from '../../shared/services/error.service';

@Component({
    selector: 'nce-earthwork-details',
    templateUrl: 'earthwork-details.component.html'
})
export class NceEarthworkDetailsComponent{

    isExtensionNCE: string;

    vMinEstimatedCompletion = new Date();
    vMinDurationTo = new Date();

    vMHNumber: string  = '';

    constructor(
        private _nceService: NceService,
        private _layoutService: LayoutService, 
        private _pageNavigationService: PageNavigationService,
        private _storageService: StorageService,
        private _errorService: ErrorService
    ) {
        
    }

    getRequestID(){
        return this._nceService.vDetailNCE.nce_request_id || this._nceService.vNCEData.nce_request_id || this._nceService.vNCEID.nce_request_id;
    }

    ngOnInit() {
        this._layoutService.setCurrentPage('nce-earthwork-details');
        this.isExtensionNCE = this._storageService.getSessionItem('extensionNCE');
        /*if(this.isExtensionNCE === '0') {
            this._nceService.resetNCEData();
            this._nceService.resetEarthworkDetails();
        }*/
        this._nceService.resetNCEData();
        this._nceService.resetEarthworkDetails();
        this._nceService.resetError();

        this.vMinDurationTo = new Date(this.getEarthworkDetails().duration_from_date);
        this.vMinDurationTo.setDate(this.vMinDurationTo.getDate() + 1);

        this.vMinEstimatedCompletion = new Date(this.getEarthworkDetails().actual_start_date);
        this.vMinEstimatedCompletion.setDate(this.vMinEstimatedCompletion.getDate() + 1);
    }

    getEarthworkDetails(){
        return this._nceService.getEarthworkDetails();
    }

    getErrorStatusAndMessage(){
        return this._errorService.getErrorStatusAndMessage();
    }

    getAllEarthworkRemarks(){
        return STATIC_VALUE.NCE_EARTHWORK_REMARKS;
    }

    isDisableSubmit(){
        return this._nceService.isDisableSaveEarthworkDetails();
    }

    isLoading(){
        return this._nceService.isLoading();
    }

    setMinDurationTo(pSelectedDate){
        this.vMinDurationTo = new Date(pSelectedDate);
        this.vMinDurationTo.setDate(this.vMinDurationTo.getDate() + 1);
        let vDurationTo = new Date(this.getEarthworkDetails().duration_to_date);
        if(pSelectedDate.getTime() >= vDurationTo.getTime()){
            this.getEarthworkDetails().duration_to_date = '';
        }
    }

    setMinEstimatedCompletion(pSelectedDate){
        this.vMinEstimatedCompletion = new Date(pSelectedDate);
        this.vMinEstimatedCompletion.setDate(this.vMinEstimatedCompletion.getDate() + 1);
        let vEstimateEnd = new Date(this.getEarthworkDetails().estimate_end_date);
        if(pSelectedDate.getTime() >= vEstimateEnd.getTime()){
            this.getEarthworkDetails().estimate_end_date = '';
        }
    }

    addMHNumber() {
        this._nceService.resetError();
        if(!this.validateMHNumber()) {
            return;
        }
        this.getEarthworkDetails().manholes_number.push(this.vMHNumber);
        this.vMHNumber = '';
    }

    validateMHNumber() {
        if(!/^MH-[0-9]+$/.test(this.vMHNumber)){
            this._errorService.setErrorFlag(true);
            this._errorService.setErrorStatusAndMessage('manholeNumber', 'Manhole Number must be MH-number');
            return false;
        } else if(this.getEarthworkDetails().manholes_number.indexOf(this.vMHNumber) > -1) {
            this._errorService.setErrorFlag(true);
            this._errorService.setErrorStatusAndMessage('manholeNumber', 'This manhole number has been added');
            return false;
        }
        return true;
    }

    removeMHNumber(pIndex: number) {
        this.getEarthworkDetails().manholes_number.splice(pIndex, 1);
    }

    submitEarthworkDetails(){
        if(this.isExtensionNCE === '0') {
            this._nceService.saveEarthworkDetails();
        } else {
            this._nceService.saveEarthworkDetailsExt();
        }
    }

    goBack(){
        let vLink;
        if(this.isExtensionNCE === '1') {
            vLink = ['nce-application/fill-in-particulars-ext'];
        } else {
            vLink = ['nce-application/fill-in-particulars'];
        }
        this._pageNavigationService.navigate(vLink);
    }
}


// WEBPACK FOOTER //
// /home/maheshreddy/PRP_FE/src/app/nce/components/earthwork-details.component.ts